import { render, staticRenderFns } from "./ShowProduct.vue?vue&type=template&id=3e1b744a&scoped=true"
import script from "./ShowProduct.vue?vue&type=script&lang=js"
export * from "./ShowProduct.vue?vue&type=script&lang=js"
import style0 from "./ShowProduct.vue?vue&type=style&index=0&id=3e1b744a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1b744a",
  null
  
)

export default component.exports